import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App.tsx";
import { Embutido } from "./Embutido.tsx";
import { EMBUTIDO } from "./lib/embutido.ts";
import "./styles.css";

const cliente = new QueryClient({
  defaultOptions: {
    queries: {
      // Dado financeiro não muda de segundo em segundo, e a sincronização com o
      // Conta Azul roda algumas vezes ao dia. Refazer a consulta a cada foco de
      // janela só gastaria banco sem mudar número na tela.
      refetchOnWindowFocus: false,
      staleTime: 60_000,
      // Erro de regra de negócio (4xx) não melhora com nova tentativa; só o de
      // rede melhora. Repetir um 422 esconderia a mensagem do usuário.
      retry: (tentativas, erro) => {
        const status = (erro as { status?: number })?.status ?? 0;
        if (status >= 400 && status < 500) return false;
        return tentativas < 2;
      },
    },
  },
});

createRoot(document.getElementById("raiz")!).render(
  <StrictMode>
    <QueryClientProvider client={cliente}>
      {/* Dentro do Arena (22/10), só o Painel do Gestor: Embutido.tsx. */}
      {EMBUTIDO ? <Embutido /> : <App />}
    </QueryClientProvider>
  </StrictMode>,
);
